import type { FaireProductEntity } from "../../entity_types/product";

export const p_p3nz2dxwfv: FaireProductEntity = {
  token: "p_p3nz2dxwfv",
  type: "product",
  name: "Cucumber Melon Non-Alcoholic Kombucha",
  brandToken: "b_s2jesyk5p9",
  brandName: "Walker Brothers",
  imageUrl: "https://cdn.faire.com/fastly/a9daa81b9149db395577056300a663b6efb6321eaf871e6df42549f464f6dd09.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8fb8f4dc5fc6c3c7a37cc5fb86903fe373b588b2a02ec6d5e6b9dec92f03fea4.jpeg",
    "https://cdn.faire.com/fastly/665dabf32e1d91575507ff0e9b5bf7e8061a5cb1b18d81e53da877c014f301e9.jpeg",
    "https://cdn.faire.com/fastly/215b44f4b1c01280b189639efcc726097925f46a12a395dee8090287e77e16d4.jpeg",
    "https://cdn.faire.com/fastly/b67fb7377dfd1a6cebbc83037beba153b99a5581b77a22ea38b910e1c2153b27.jpeg",
    "https://cdn.faire.com/fastly/22c1a97bb32a0acacb30bb36c203e9491370864c8e3a3885a21414acf8a7b150.png"
  ],
  priceDollars: 2.25,
  description: "Organic cucumber and watermelon juice harmonize with our signature tea blend in this craft non-alcoholic kombucha to create a tart yet hydrating, effervescent kombucha with a balanced body and clean finish. \n\n***Please note: This item must be kept refrigerated.***\n\nIngredients: Raw Kombucha (Filtered Water, Kombucha Culture, Black Tea*, Green Tea*, Jasmine Tea*, Cane Sugar*), Watermelon Juice*, Cucumber Juice*\n*certified organic ingredients\n\nWalker Brothers Cucumber Melon craft kombucha is unpasteurized and rich in live probiotics, gluten-free, kosher pareve, and vegan.\n\nPackaged in an aluminum can for ease of recycling \n\n\nA healthy, non-alcoholic option for fall gatherings, tailgates, Halloween, Thanksgiving, Friendsgiving and holiday parties! A great mixer for drinks as well as a good snack pairing with chips and popcorn. ",
  tags: [],
  msrpDollars: 4.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-09T08:04:40.035Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
